import { EnergyCost } from './energy-cost.model';

export class TotalEnergyCost {
	electric: EnergyCost;
	diesel: EnergyCost;
	gas: EnergyCost;
	electricComp: EnergyCost;
}
